<!-- Ported from the Polaris kit: src/components/ui/breadcrumb/BreadcrumbList.vue.
     Classes translated to Tailwind 3 by rebranding_frontend/port-kit-component.mjs.
     Change the design in the kit first, then re-port. -->
<script setup>
import { cn } from '../../lib/utils';

const props = defineProps({
  class: {
    type: [Boolean, null, String, Object, Array],
    required: false,
    skipCheck: true,
  },
});
</script>

<template>
  <ol
    data-slot="breadcrumb-list"
    :class="
      cn(
        'text-polaris-muted-foreground flex flex-wrap items-center gap-1.5 type-polaris-label break-words sm:gap-2.5',
        props.class
      )
    "
  >
    <slot />
  </ol>
</template>
